export enum EmbedTypes {
  Tweet = "tweet",
}
